import { useState, useEffect } from 'react';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';
import { StepContent } from '../StepContent';
import type { GroupedSelectOptionType } from '../../../utils/form-options';
import { HdeOptionList } from '../HDEOptionList';

const HDE_PRODUCT_INTERESTS: GroupedSelectOptionType[] = [
    { label: 'Bathroom Products', value: 'Bathroom Products' },
    { label: 'Building Products', value: 'Building Products' },
    { label: 'Finishes Products', value: 'Finishes Products' },
    { label: 'Furniture Products', value: 'Furniture Products' },
    { label: 'Lighting Products', value: 'Lighting Products' },
    { label: 'Home Living Products', value: 'Home Living Products' },
    { label: 'Outdoor Products', value: 'Outdoor Products' },
    { label: 'Kitchen Products', value: 'Kitchen Products' },
];

interface ProductInterestsData {
    productInterests: GroupedSelectOptionType[];
}

export function ProductInterestsStep({
    setIsValid,
    onDataChange,
    initialData,
}: StepContentProps) {
    const data = initialData as ProductInterestsData | undefined;
    const [productInterests, setProductInterests] = useState<
        GroupedSelectOptionType[]
    >(data?.productInterests || []);

    useEffect(() => {
        setIsValid(productInterests.length > 0);
        onDataChange?.({ productInterests });
    }, [productInterests, setIsValid, onDataChange]);

    return (
        <div className="flex min-h-0 flex-col">
            <StepContent>
                <div className="space-y-3">
                    <HdeOptionList
                        label="Which product types are you interested in? *"
                        mode="multi"
                        options={HDE_PRODUCT_INTERESTS}
                        value={productInterests}
                        onChange={setProductInterests}
                    />
                </div>
            </StepContent>
        </div>
    );
}
